import { PropsWithChildren } from "react"
import { makeStyles } from "tss-react/mui"
import { Grid } from "@mui/material"

const useStyles = makeStyles()((theme) => ({
    cardGroup: {
        gap: "2rem",
    },
}))

type CardGroupProps = Readonly<
    PropsWithChildren<{
        title?: string
        subtitle?: string
    }>
>

export function CardGroup({ children }: CardGroupProps) {
    const { classes } = useStyles()

    return (
        <Grid container className={classes.cardGroup}>
            {children}
        </Grid>
    )
}
